import { useNavigate } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import './instructions.css';
import { getCandidateDataStatus, getCandidateSignature, saveCandidateSignature } from '../../../services/candidate/api';
import PopupModel from '../../popup-model/PopupModel';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Instructions = () => {
  const navigate = useNavigate();

  const [checkboxes, setCheckboxes] = useState({ consent1: false, consent2: false });
  const [signature, setSignature] = useState(null);
  const [typedSignature, setTypedSignature] = useState('');
  const [tab, setTab] = useState('draw');
  const canvasRef = useRef(null);
  const isDrawing = useRef(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [isSignatureSubmitted, setIsSignatureSubmitted] = useState(false);
  const [showAadhaarPopup, setShowAadhaarPopup] = useState(false);
  const [showAadhaarOtp, setShowAadhaarOtp] = useState(false);
  const [aadhaarNumber, setAadhaarNumber] = useState('');
  const [aadhaarOtp, setAadhaarOtp] = useState('');
  const [clientId, setClientId] = useState(null);
  const [aadhaarError, setAadhaarError] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpStage, setOtpStage] = useState(false);
  const [timer, setTimer] = useState(600); 
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    const dashboardWrapper = document.querySelector('.dashboard-container');
    if (dashboardWrapper) {
      dashboardWrapper.style.backgroundImage = 'none';
      dashboardWrapper.style.backgroundColor = '#f4f4f4';
    }
    document.body.classList.add('no-background');

    return () => {
      if (dashboardWrapper) {
        dashboardWrapper.style.backgroundImage = '';
        dashboardWrapper.style.backgroundColor = '';
      }
      document.body.classList.remove('no-background');
    };
  }, []);

useEffect(() => {
  let countdown;

  if (otpStage) {
    countdown = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(countdown);
          return 0;
        }

        // Enable resend after 2 minutes 
        if (prev <= 480) {
          setCanResend(true);
        }

        return prev - 1;
      });
    }, 1000);
  }

  return () => clearInterval(countdown);
}, [otpStage]);




  useEffect(() => {
    const fetchSignature = async () => {
      try {
        const response = await getCandidateSignature();
        const signatureUrl = response?.data?.signatureFileUrl;
        if (signatureUrl) {
          setSignature(signatureUrl);
          setIsSignatureSubmitted(true);
        } else {
          setSignature(null);
          setIsSignatureSubmitted(false);
        }
      } catch (error) {
        console.error('Error fetching signature:', error);
        setSignature(null);
        setIsSignatureSubmitted(false);
      }
    };
    fetchSignature();
  }, []);

  const formatTime = (seconds) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${m}:${s}`;
};
const startTimer = () => {
  setTimer(600);       
  setCanResend(false);
};


const initCanvas = (canvas, updateState = true) => {
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  const cssWidth = 800;
  const cssHeight = 200;
  const dpr = window.devicePixelRatio || 1;

  // backing store
  canvas.width = cssWidth * dpr;
  canvas.height = cssHeight * dpr;

  canvas.style.width = `${cssWidth}px`;
  canvas.style.height = `${cssHeight}px`;

  ctx.setTransform(1, 0, 0, 1, 0, 0); // reset
  ctx.scale(dpr, dpr); // scale for DPR

  // fill background
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, cssWidth, cssHeight);

  ctx.lineWidth = 1.5 * dpr;   // was 2.5
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.strokeStyle = "#000000";

  if (updateState && signature) {
    setSignature(canvas.toDataURL("image/png", 1.0));
  }
};




// run once when component mounts
useEffect(() => {
  if (canvasRef.current) {
    initCanvas(canvasRef.current, false);
  }
}, []);


// also re-init when switching back to draw tab
useEffect(() => {
  if (tab === "draw" && canvasRef.current) {
    initCanvas(canvasRef.current, true);
  }
}, [tab]);


  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes(prev => ({ ...prev, [name]: checked }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size < 2 * 1024 * 1024 && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSignature(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert('Only images under 2MB are allowed.');
    }
  };


  const handleTypedSignature = (e) => {
    const typedText = e.target.value;
    setTypedSignature(typedText);

    const canvas = document.createElement('canvas');
    const dpr = window.devicePixelRatio || 1;
    canvas.width = 300 * dpr;
    canvas.height = 100 * dpr;
    canvas.style.width = '300px';
    canvas.style.height = '100px';

    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, 300, 100);
    ctx.font = '24px cursive';
    ctx.fillStyle = 'black';
    ctx.fillText(typedText, 10, 50);
    setSignature(canvas.toDataURL('image/png', 1.0));
  };

  const getEventPosition = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: clientX - rect.left, y: clientY - rect.top };
  };



const startDrawing = (e) => {
  if (tab !== 'draw' || !canvasRef.current) return;
  e.preventDefault();
  isDrawing.current = true;

  const { x, y } = getEventPosition(e);
  const ctx = canvasRef.current.getContext('2d');

  ctx.lineWidth = 1.5 * (window.devicePixelRatio || 1); 
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.strokeStyle = "#000000";

  ctx.beginPath();
  ctx.moveTo(x, y);
};



  const draw = (e) => {
    if (!isDrawing.current || tab !== 'draw' || !canvasRef.current) return;
    e.preventDefault();
    const { x, y } = getEventPosition(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const endDrawing = () => {
    if (tab !== 'draw' || !canvasRef.current) return;
    isDrawing.current = false;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.closePath();
    const dataUrl = canvas.toDataURL('image/png', 1.0);
    setSignature(dataUrl);
  };

  const clearCanvas = () => {
    initCanvas(canvasRef.current, true);
  };



  const isCanvasEmpty = (canvas) => {
    const ctx = canvas.getContext('2d');
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    return pixelData.every((val, i) => i % 4 === 3 ? val === 255 : val === 255);
  };

  const handleConfirmSign = async () => {
    setShowConfirmPopup(false);
    if (!signature) {
      alert("Please provide a signature.");
      return;
    }

    if (tab === 'draw' && canvasRef.current && isCanvasEmpty(canvasRef.current)) {
      alert("Please draw a signature on the canvas.");
      return;
    }

    if (tab === 'type' && !typedSignature.trim()) {
      alert("Please type a signature.");
      return;
    }

    if (tab === 'upload' && !signature) {
      alert("Please upload a signature image.");
      return;
    }

    try {
      const blob = await (await fetch(signature)).blob();
      const file = new File([blob], "signature.png", { type: "image/png" });

      await saveCandidateSignature(file, tab);
      toast.success("Signature saved successfully", {
                      autoClose: 3000, // 3 seconds
                      });
      setIsSignatureSubmitted(true);
    } catch (error) {
      console.error('Error saving signature:', error);
      alert('Error saving signature.');
    }
  };

  const handleAadhaarSubmit = async () => {
    setAadhaarError('');
    setIsLoading(true);
    //  setOtpStage(true);
    const cleanAadhaar = aadhaarNumber.replace(/\s/g, '');

    if (!cleanAadhaar || !/^\d{12}$/.test(cleanAadhaar)) {
      setAadhaarError('Please enter a valid 12-digit Aadhaar number.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch('https://kyc-api.surepass.app/api/v1/aadhaar-v2/generate-otp', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1MTA4NzkxNywianRpIjoiOTk0MWMzMGUtNGY4Ny00NTNkLWE0OTEtODNkNmZiNDE0OGEzIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsIm5iZiI6MTc1MTA4NzkxNywiZXhwIjoyMzgxODA3OTE3LCJlbWFpbCI6InVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.HJHPVrHRTVD0wwXiiI226F7A7r_fIAjMvVaChKoc6W8',
          'Content-Type': 'application/json',
          'Tenant-Id': 'main'
        },
        body: JSON.stringify({ id_number: cleanAadhaar, tenant_id: 'main' })
      });

      const data = await response.json();
      // alert("OTP sent Successfully! ");
      toast.success("OTP sent successfully!", {
        position: "top-center", 
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });

      //console.log('Surepass Generate OTP Response:', JSON.stringify(data, null, 2));

      if (data.success === true && data.data?.client_id) {
        setClientId(data.data.client_id);
        // setShowAadhaarPopup(false);
        startTimer();
       setOtpStage(true);
        setAadhaarError('');
      } else {
          setOtpStage(false); 
        setAadhaarError(data.error?.message || 'Failed to generate OTP. Please try again.');
      }
    } catch (error) {
      console.error('API Error - Generate OTP:', error);
       setOtpStage(false);     
      setAadhaarError('Server Error. Contact support if the error persists.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    setAadhaarError('');
    setIsLoading(true);

    if (!aadhaarOtp) {
      setAadhaarError('Please enter the OTP.');
      setIsLoading(false);
      return;
    }

    if (!clientId) {
      setAadhaarError('Client ID is missing. Please re-enter your Aadhaar number.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch('https://kyc-api.surepass.app/api/v1/aadhaar-v2/submit-otp', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1MTA4NzkxNywianRpIjoiOTk0MWMzMGUtNGY4Ny00NTNkLWE0OTEtODNkNmZiNDE0OGEzIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsIm5iZiI6MTc1MTA4NzkxNywiZXhwIjoyMzgxODA3OTE3LCJlbWFpbCI6InVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.HJHPVrHRTVD0wwXiiI226F7A7r_fIAjMvVaChKoc6W8',
          'Content-Type': 'application/json',
          'Tenant-Id': 'main'
        },
        body: JSON.stringify({ client_id: clientId, otp: aadhaarOtp })
      });

      const data = await response.json();
      //console.log('Surepass Submit OTP Response:', JSON.stringify(data, null, 2));

      if (data.success === true && data.data) {
        const { full_name, aadhaar_number, dob, gender, care_of, profile_image, address, zip } = data.data;

        // Store personal_response in sessionStorage
        localStorage.setItem('personal_response', JSON.stringify({
          full_name,
          aadhaar_number,
          dob,
          gender,
          care_of,
          profile_image
        }));
        //console.log("personal " + sessionStorage.getItem('personal_response'));
        // Store address_response in sessionStorage
        localStorage.setItem('address_response', JSON.stringify({ address, zip }));
        //console.log("Address " + sessionStorage.getItem('address_response'));

        // alert('Aadhaar verified successfully!');
        setShowAadhaarOtp(false);
        navigate('/candidate/personal-info');
      } else {
        setAadhaarError(data.error?.message || 'Invalid OTP or unexpected response. Please try again.');
      }
    } catch (error) {
      console.error('API Error - Submit OTP:', error);
      setAadhaarError('Server Error. Contact support if the error persists.');
    } finally {
      setIsLoading(false);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!checkboxes.consent1 || !checkboxes.consent2 || !isSignatureSubmitted) {
      alert('Please check both consent boxes and submit a signature.');
      return;
    }
  };


const handleSaveAndContinue = async () => {
  try {
    const response = await getCandidateDataStatus();
    const { dataComplete } = response?.data || {};

    if (dataComplete) {
      // ✅ Skip Aadhaar popup and move to next page
      navigate('/candidate/personal-info');
    } else {
      // ❌ Show Aadhaar popup
      setShowAadhaarPopup(true);
    }
  } catch (error) {
    console.error("Error checking candidate data status:", error);
    alert("Failed to check candidate data status. Please try again.");
  }
};
  
  return (
    <div className="instructions-wrapper">
      <div className="instructions-form-container">
        <div className="instructions-block">
          <p>1. This form is divided into the following sections:<br />- Personal Details<br />- Address Details<br />- Education Details<br />- Employment Details<br />- Other Details (Criminal, Finance, Medical)</p>
          <p>2. Fields marked with * are mandatory.</p>
          <p>3. Some details will be shown in the review section and can be edited there. Others require email communication to modify.</p>
          <p>4. Email <strong>somename@email.com</strong> to change non-editable fields.</p>
          <p>5. Provide only correct and legitimate information. Misrepresentation can affect your offer.</p>
          <p>6. Review all details carefully before submitting.</p>
          <p className="instructions-note">Note: Once submitted, data cannot be changed on the website.</p>
          <p className="instructions-note">Note: You can log in for 5 days from the BGC invitation date.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="instructions-checkbox-group">
            <input type="checkbox" id="consent1" name="consent1" checked={checkboxes.consent1} onChange={handleCheckboxChange} />
            <label htmlFor="consent1">I agree to share my personal, academic, education, employment info with the organization for background check verification.</label>
          </div>
          <div className="instructions-checkbox-group">
            <input type="checkbox" id="consent2" name="consent2" checked={checkboxes.consent2} onChange={handleCheckboxChange} />
            <label htmlFor="consent2">I agree that the organization may share my information with third parties if necessary.</label>
          </div>

          {(checkboxes.consent1 && checkboxes.consent2) && (
            <div className="instructions-signature-section">
              <h3>Provide Signature</h3>
              <div className="signature-center-wrapper">
                <div className="instructions-signature-section-container">
                  {isSignatureSubmitted && signature ? (
                    <div className="instructions-signature-preview">
                      <p><strong>Your Submitted Signature:</strong></p>
                      <img src={signature} alt="Saved Signature" style={{ maxWidth: '100%', border: '1px solid #ccc', margin: '10px 0' }} />
                      <p style={{ color: 'green', fontWeight: 'bold', textAlign: 'center' }}>✔ Signature already submitted. Cannot edit.</p>
                    </div>
                  ) : (
                    <>
                      <div className="instructions-tabs" style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                        <button type="button" className="instructions-tab-btn" onClick={() => setTab('draw')}>Draw</button>
                        <button type="button" className="instructions-tab-btn" onClick={() => setTab('type')}>Type</button>
                        <button type="button" className="instructions-tab-btn" onClick={() => setTab('upload')}>Upload</button>
                      </div>

                      {tab === 'draw' && (
                        <div className="instructions-draw-section" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
<canvas
  ref={canvasRef}
  width={837}
  height={250}
  className="instructions-signature-canvas"
  onMouseDown={startDrawing}
  onMouseMove={draw}
  onMouseUp={endDrawing}
  onMouseLeave={endDrawing}
  onTouchStart={startDrawing}
  onTouchMove={draw}
  onTouchEnd={endDrawing}
/>


                        </div>
                      )}

                      {tab === 'type' && (
                        <input
                          type="text"
                          value={typedSignature}
                          placeholder="Type your signature"
                          onChange={handleTypedSignature}
                          className="instructions-type-input"
                          style={{ width: '100%', maxWidth: '500px', margin: '10px auto', display: 'block' }}
                        />
                      )}

                      {tab === 'upload' && (
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                          className="instructions-upload-input"
                          style={{ width: '100%', maxWidth: '500px', margin: '10px auto', display: 'block' }}
                        />
                      )}
                      {signature && (
                        <div className='preview-clear-button'>
                          <div className='preview-clear-button-data'>
                            {!showPreview && (
                              <button
                                type="button"
                                className="instructions-preview-btn"
                                onClick={() => setShowPreview(true)}
                              >
                                Preview
                              </button>
                            )}

                            {showPreview && (
                              <div className="instructions-signature-preview">
                                <p><strong>Preview:</strong></p>
                                <img src={signature} alt="Signature Preview" style={{ maxWidth: '100%', border: '1px solid #ccc' }} />
                              </div>
                            )}

                            <button type="button" className="instructions-clear-btn" onClick={clearCanvas}>Clear</button>
                          </div>
                        </div>
                      )}

                      <button
                        type="button"
                        className="instructions-sign-btn"
                        onClick={() => setShowConfirmPopup(true)}
                        style={{ width: '100px', marginTop: '10px' }}
                      >
                        Sign
                      </button>
                    </>
                  )}
                </div>
              </div>

              <div className="instructions-form-actions">
                <button
                  type="button"
                  disabled={!(checkboxes.consent1 && checkboxes.consent2 && isSignatureSubmitted)}
                  className="instructions-submit-btn"
                  onClick={handleSaveAndContinue}
                >
                  Save & Continue
                </button>
              </div>
            </div>
          )}

         {showAadhaarPopup && (
  <div className="popup-overlay" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <div className="popup" >
      <h4 className='popup-h4'>Aadhaar Verification</h4>
      {/* <p>Please enter your Aadhaar number to continue</p> */}

      {/* Aadhaar Input */}
      <div className="aadhar-container" style={{ margin: '20px 0',}}>
        <label >Aadhaar Number</label>
        <input
          type="text"
          value={aadhaarNumber}
          disabled={otpStage} // disable after Aadhaar submit
          onChange={(e) => {
            let value = e.target.value.replace(/\D/g, '');
            if (value.length > 12) value = value.slice(0, 12);
            const formatted = value.replace(/(.{4})/g, '$1 ').trim();
            setAadhaarNumber(formatted);
          }}
          maxLength={14}
          placeholder="XXXX XXXX XXXX"
          className="aadhaar-input"
          // style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
        />
        {aadhaarError && <p style={{ color: 'red', marginTop: '10px' }}>{aadhaarError}</p>}
      </div>

      
    {otpStage && (
    <div className="otp-container" style={{ margin: '20px 0' }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <label>OTP</label>
        <span style={{ fontSize: "14px", color: "gray" }}>
          {timer > 0 ? `Time left: ${formatTime(timer)}` : "Expired"}
        </span>
      </div>

      <input
        type="text"
        maxLength={6}
        value={aadhaarOtp}
        onChange={(e) => setAadhaarOtp(e.target.value)}
        placeholder="Enter 6-digit OTP"
        className="aadhaar-input"
      />

      {aadhaarError && (
        <p style={{ color: 'red', marginTop: '10px' }}>{aadhaarError}</p>
      )}

   <button
  type="button"
  className="resend-otp-btn"
  onClick={handleAadhaarSubmit}  
  disabled={!canResend}
>
  Resend OTP
</button>

    </div>
  )}

      {/* Action Buttons */}
      <div className="popup-actions" style={{ display: 'flex', justifyContent: 'center', gap: '30px' }}>
        <button
          onClick={() => {
            setShowAadhaarPopup(false);
            setAadhaarError('');
            setOtpStage(false);
            setAadhaarOtp('');
          }}
          style={{ width: '100px' }}
        >
          Cancel
        </button>

        {!otpStage ? (
          <button onClick={handleAadhaarSubmit} disabled={isLoading} style={{ width: '130px' }}>
            {isLoading ? 'Submitting...' : 'Submit'}
          </button>
        ) : (
          <button onClick={handleOtpSubmit} disabled={isLoading} style={{ width: '140px' }}>
            {isLoading ? 'Verifying...' : 'Verify & Continue'}
          </button>
        )}
      </div>
    </div>
  </div>
)}


          {/* {showAadhaarOtp && (
            <div className="popup-overlay" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className="popup" style={{ maxWidth: '400px', padding: '20px', textAlign: 'center' }}>
                <h4>OTP Verification</h4>
                <p>Enter the OTP sent to your registered mobile number</p>
                <div className="aadhar-container" style={{ margin: '20px 0' }}>
                  <label style={{ display: 'block', marginBottom: '10px' }}>OTP</label>
                  <input
                    type="text"
                    maxLength={6}
                    value={aadhaarOtp}
                    onChange={(e) => setAadhaarOtp(e.target.value)}
                    placeholder="Enter 6-digit OTP"
                    className="aadhaar-input"
                    style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                  />
                  {aadhaarError && <p style={{ color: 'red', marginTop: '10px' }}>{aadhaarError}</p>}
                </div>
                <div className="popup-actions" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                  <button onClick={() => { setShowAadhaarOtp(false); setAadhaarError(''); }} style={{ width: '100px' }}>Cancel</button>
                  <button
                    onClick={handleOtpSubmit}
                    disabled={isLoading}
                    style={{ width: '100px' }}
                  >
                    {isLoading ? 'Verifying...' : 'Verify & Continue'}
                  </button>
                </div>
              </div>
            </div>
          )} */}

          {showConfirmPopup && (
            <div className="popup-overlay" >
              <div className="popup-content" >
                <h3>Confirmation</h3>
                <p className='popup-title'>Click OK to Submit the Signature</p>
                <div className="popup-actions" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                  <button type="button" onClick={() => setShowConfirmPopup(false)} style={{ width: '100px' }}>Cancel</button>
                  <button type="button" onClick={handleConfirmSign} style={{ width: '100px' }}>OK</button>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Instructions; 